<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">LED信息发布</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
          <el-form-item label="标题" prop="title">
            <el-input
              v-model="queryParams.title"
              placeholder="请输入公告标题"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="发送时间" prop="dateRange">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width:60rem;"
              unlink-panels
            ></el-date-picker>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onReset">重 置</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>

      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添加公告</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="noticeList"
              v-loading="loading"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="title"
                label="公告标题"
                min-width="160"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="content"
                label="公告内容"
                min-width="220"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="sendTime"
                label="发送时间"
                width="170"
              ></el-table-column>
              <el-table-column
                label="发送人"
                width="120"
              >
                <template slot-scope="scope">
                  {{ scope.row.sendUser || scope.row.createBy || '-' }}
                </template>
              </el-table-column>
              <el-table-column
                label="目标LED设备"
                min-width="220"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ formatTargets(scope.row.targetList) }}
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="160"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    @click="onView(scope.row)"
                    type="text"
                    size="small"
                    >查看详细</el-button
                  >
                  <el-button
                    @click="onDelete(scope.row)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>

      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>

    <!-- 新增公告弹窗 -->
    <el-dialog
      title="添加公告"
      :visible.sync="addDialogVisible"
      width="600px"
      custom-class="led-notice-add-dialog"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      @closed="resetAddForm"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :rules="addRules"
        label-width="120px"
      >
        <el-form-item label="公告标题" prop="title">
          <el-input
            v-model="addForm.title"
            placeholder="请输入公告标题"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="公告内容" prop="content">
          <el-input
            v-model="addForm.content"
            type="textarea"
            :rows="4"
            placeholder="请输入公告内容"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="目标LED设备" prop="targetCodes">
          <el-select
            v-model="addForm.targetCodes"
            multiple
            collapse-tags
            filterable
            placeholder="请选择目标LED设备"
            style="width: 100%"
          >
            <el-option
              v-for="item in deviceOptions"
              :key="item.equipmentCode"
              :label="item.equipmentName"
              :value="item.equipmentCode"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="onAddCancel">取 消</el-button>
        <el-button
          type="primary"
          :loading="submitting"
          @click="onAddSubmit"
          >发 送</el-button
        >
      </span>
    </el-dialog>

    <!-- 详情弹窗（只读） -->
    <el-dialog
      title="公告详情"
      :visible.sync="detailVisible"
      width="600px"
      :destroy-on-close="true"
    >
      <el-form label-width="120px" v-if="detailData">
        <el-form-item label="公告标题">
          <span>{{ detailData.title }}</span>
        </el-form-item>
        <el-form-item label="公告内容">
          <span style="white-space: pre-wrap">{{ detailData.content }}</span>
        </el-form-item>
        <el-form-item label="发送时间">
          <span>{{ detailData.sendTime }}</span>
        </el-form-item>
        <el-form-item label="发送人">
          <span>{{ detailData.sendUser || detailData.createBy || '-' }}</span>
        </el-form-item>
        <el-form-item label="目标LED设备">
          <div v-if="detailData.targetList && detailData.targetList.length">
            <div
              v-for="(t, idx) in detailData.targetList"
              :key="idx"
            >
              {{ t.equipmentName }}（{{ t.equipmentIp }}）
            </div>
          </div>
          <span v-else>-</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="detailVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  listLedDevice,
  listLedNotice,
  getLedNotice,
  addLedNotice,
  delLedNotice,
} from "@/api/src/led";

export default {
  name: "LedNoticeManagerView",
  controller: "UI",
  action: "LedNoticeManagerView",
  data() {
    return {
      loading: false,
      submitting: false,
      total: 0,
      noticeList: [],
      // 查询条件
      queryParams: {
        title: null,
        startTime: null,
        endTime: null,
        pageNum: 1,
        pageSize: 10,
      },
      dateRange: [],
      // 设备下拉
      deviceOptions: [],
      // 新增弹窗
      addDialogVisible: false,
      addForm: {
        title: "",
        content: "",
        targetCodes: [],
      },
      addRules: {
        title: [
          { required: true, message: "请输入公告标题", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入公告内容", trigger: "blur" },
        ],
        targetCodes: [
          {
            required: true,
            type: "array",
            message: "请选择目标LED设备",
            trigger: "change",
          },
        ],
      },
      // 详情弹窗
      detailVisible: false,
      detailData: null,
    };
  },
  mounted() {
    this.getList();
    this.loadDevices();
  },
  methods: {
    // 加载设备下拉
    loadDevices() {
      listLedDevice()
        .then((res) => {
          this.deviceOptions = res.data || res.rows || [];
        })
        .catch((e) => console.error(e));
    },
    // 列表查询
    getList() {
      this.loading = true;
      // 后端 LedNoticeQueryDTO 的 startTime / endTime 配置格式为 yyyy-MM-dd HH:mm:ss，
      // 而 date-picker 只输出 yyyy-MM-dd，这里把日期补成完整时间再发送：
      //   开始日期 -> 00:00:00；结束日期 -> 23:59:59，避免结束当天的数据被排除。
      const startDate = this.dateRange && this.dateRange[0] ? this.dateRange[0] : null;
      const endDate = this.dateRange && this.dateRange[1] ? this.dateRange[1] : null;
      const params = {
        title: this.queryParams.title || undefined,
        startTime: startDate ? `${startDate} 00:00:00` : undefined,
        endTime: endDate ? `${endDate} 23:59:59` : undefined,
        pageNum: this.queryParams.pageNum,
        pageSize: this.queryParams.pageSize,
      };
      listLedNotice(params)
        .then((res) => {
          this.noticeList = res.rows || [];
          this.total = res.total || 0;
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.loading = false;
        });
    },
    onSearch() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    onReset() {
      this.queryParams.title = null;
      this.dateRange = [];
      this.queryParams.pageNum = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
    // 目标设备列展示
    formatTargets(list) {
      if (!list || !list.length) return "-";
      return list.map((t) => t.equipmentName).join("、");
    },
    // 新增
    onAdd() {
      this.addDialogVisible = true;
      // 弹出时刷新一次设备列表，避免上线/离线变化未同步
      this.loadDevices();
    },
    onAddCancel() {
      this.addDialogVisible = false;
    },
    resetAddForm() {
      this.addForm = { title: "", content: "", targetCodes: [] };
      if (this.$refs.addForm) {
        this.$refs.addForm.clearValidate();
      }
    },
    onAddSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        const targetList = this.deviceOptions
          .filter((d) => this.addForm.targetCodes.includes(d.equipmentCode))
          .map((d) => ({
            terminalId: d.terminalId,
            equipmentCode: d.equipmentCode,
            equipmentName: d.equipmentName,
            equipmentIp: d.equipmentIp,
          }));
        const body = {
          title: this.addForm.title,
          content: this.addForm.content,
          targetList: targetList,
        };
        this.submitting = true;
        addLedNotice(body)
          .then(() => {
            this.$message.success("发送成功");
            this.addDialogVisible = false;
            this.queryParams.pageNum = 1;
            this.getList();
          })
          .catch((e) => {
            // 拦截器已弹错误信息；此处仅打印
            console.error(e);
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
    // 查看详情
    onView(row) {
      getLedNotice(row.id)
        .then((res) => {
          this.detailData = res.data || res.rows || row;
          this.detailVisible = true;
        })
        .catch((e) => console.error(e));
    },
    // 删除
    onDelete(row) {
      this.$confirm("此操作将永久删除该条公告, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delLedNotice(row.id)
            .then(() => {
              this.$message.success("删除成功");
              // 末页删空时回退一页
              if (
                this.noticeList.length === 1 &&
                this.queryParams.pageNum > 1
              ) {
                this.queryParams.pageNum -= 1;
              }
              this.getList();
            })
            .catch((e) => console.error(e));
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
/* 字数统计角标：去掉默认白底，融入输入框背景 */
.led-notice-add-dialog {
  /* 表单项下方留出足够空间显示红色校验提示，避免被字数统计或下一行遮挡 */
  .el-form-item {
    margin-bottom: 28px;
  }
  .el-form-item__error {
    padding-top: 6px;
    line-height: 1.2;
    white-space: nowrap;
  }

  .el-input .el-input__count,
  .el-input .el-input__count-inner,
  .el-textarea .el-input__count,
  .el-textarea .el-input__count-inner {
    background: transparent !important;
    color: inherit;
    opacity: 0.6;
  }
}
</style>

